
import { EventType, EventAudience } from './types';

// Hungarian labels for event types with comprehensive translations
export const eventTypeLabels: Record<EventType, string> = {
  conference: 'Konferencia',
  workshop: 'Workshop',
  training: 'Továbbképzés',
  webinar: 'Webinárium',
  seminar: 'Szeminárium',
  networking: 'Kapcsolatépítés',
  exhibition: 'Kiállítás',
  meetup: 'Találkozó',
  congress: 'Kongresszus',
  course: 'Tanfolyam',
  symposium: 'Szimpózium'
};

// Hungarian labels for event audiences
export const audienceLabels: Record<EventAudience, string> = {
  doctors: 'Orvosok',
  nurses: 'Ápolók',
  medical_students: 'Orvostanhallgatók',
  pharmacists: 'Gyógyszerészek',
  healthcare_professionals: 'Egészségügyi szakemberek',
  general_public: 'Nagyközönség'
};

// Hungarian regions
export const regions = ['Budapest', 'Pest', 'Debrecen', 'Szeged', 'Miskolc', 'Pécs', 'Győr', 'Nyíregyháza', 'Kecskemét'];
